import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  margin: 64px auto;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
`
